import React from 'react'
import Main from '../components/Main'
import '../styles/App.css'

const App = () => {
  return <Main />
}

export default App